import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("❌ React Error Boundary caught an error:", error);
    console.error("📍 Error Info:", errorInfo);
    console.error("📚 Component Stack:", errorInfo.componentStack);

    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: "20px",
            backgroundColor: "#ffebee",
            border: "1px solid #f44336",
          }}
        >
          <h2>❌ Something went wrong</h2>
          <details style={{ whiteSpace: "pre-wrap" }}>
            <summary>Click to see error details</summary>
            <strong>Error:</strong>{" "}
            {this.state.error && this.state.error.toString()}
            <br />
            <strong>Component Stack:</strong>{" "}
            {this.state.errorInfo?.componentStack || 'No component stack available'}
          </details>
          <button
            onClick={() =>
              this.setState({ hasError: false, error: null, errorInfo: null })
            }
            style={{ marginTop: "10px", padding: "5px 10px" }}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
